module.exports = __webpack_public_path__ + "media/images/close_icon-ba4dc3b9.svg";